import dropdownArrow from '@/assets/icon/dropdown-arrow.svg';
import dropdownArrowWhite from '@/assets/icon/dropdown-arrow-white.svg';

// Trigger of the 'form' variant of the searchable pickers (SearchSelect,
// CodeSearchSelect): the plain <input>/<select> look of the other form fields.
// Mirrors `input, select`, `select:disabled` and the `.dark` form rules in
// styles/index.css - a <button> gets none of those rules on its own.
export const FORM_TRIGGER_CLASSES = [
  'h-[36px] px-[10px] py-[6px] text-[14px] font-normal rounded-[3px] border bg-transparent',
  'border-[color:var(--neutral-800)] text-[color:var(--black-500)]',
  'dark:border-[color:var(--db-border)] dark:text-[#e0e0e0]',
  'focus:outline-2 focus:outline-[color:var(--blueprimary-500)]',
  'dark:focus:outline-[color:var(--db-border)]',
  'disabled:bg-[color:var(--neutral-600)] disabled:border-[color:var(--neutral-600)]',
  'disabled:text-[color:var(--neutral-900)]',
  'dark:disabled:bg-[#1a2535] dark:disabled:border-[color:var(--db-border)]',
  'dark:disabled:text-[#808890]',
];

// The native select's arrow icon (white in dark mode). Like the native one, it
// is dropped while the field is disabled.
export const FormSelectArrow = ({ disabled }: { disabled?: boolean }) =>
  disabled ? null : (
    <>
      <img src={dropdownArrow} alt="" aria-hidden="true" className="w-4 h-4 shrink-0 dark:hidden" />
      <img
        src={dropdownArrowWhite}
        alt=""
        aria-hidden="true"
        className="w-4 h-4 shrink-0 hidden dark:block"
      />
    </>
  );
